/*import React from 'react'
import Helmet from 'react-helmet'

const termsConditionsEs = () => (
  <div className="page terms_conditions">
    <Helmet
      title={`Budget Nicaragua Terms & Conditions - Find a Car Rental Near You`}
      meta={[
        {
          name: 'description',
          content: 'Frequently Asked Questions about car rentals.',
        },
      ]}
      link={[
        {
          rel: 'alternate',
          hreflang: 'es',
          href: './es/terms_conditions',
        },
      ]}
    />

    {/* <div className="image"></div> }
    <h1>Terminos y Condiciones</h1>
    <br />

    <div className="wrapper">
      <div>
        <h2>Condiciones generales de renta de vehículos</h2>
        <p>
          <li> Las reservaciones son con anticipación mínima de 24 horas.</li>
          <li> La tarifa diaria aplica por un máximo de 24 horas de alquiler del vehículo.</li>
          <li> La edad mínima para clientes y conductores, es de 25 años.</li>
          <li> La tarjeta de crédito tiene que estar a nombre del cliente.</li>
          <li> La cobertura SLI es obligatoria en Budget Nicaragua.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Para rentar el vehículo se requiere:</h2>
        <p>
          <li> Documento de Identificación (Cédula de identidad o pasaporte en el caso de extranjeros)</li>
          <li>Licencia de conducir vigente</li>
          <li>Presentar tarjeta de crédito o debito al momento de rentar el vehículo</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Deposito de garantia y cancelacion:</h2>
        <p>
          <li>
          Para la renta del vehículo se requiere deposito en tarjeta de credito,el que oscila entre U$500.00 y U$1,500.00 o más dependiendo de la categoria del vehículo y la duracion de la renta.
          </li>
          <li>
          Para depósito con tarjeta de débito se requiere un monto minimo de U$600.00 - U$1,500.00 o más en dependencia de la categoría del vehículo y la duración de la renta, adicional el cliente deberá pre-pagar la renta.
          </li>
          <li>
          Para cancelacion de la renta puede utilizar tarjeta de crédito, débito o efectivo.
          </li>
          <li>Budget Nicaragua no permite el depósito inicial con tarjetas Discover, solo para cancelaci&iocute;n de la factura de renta.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Combustible</h2>
        <p>
          <li>
          El vehículo se entrega lleno de combustible y debe regresar en las mismas condiciones, este dato se especifica en el contrato de arrendamiento.
          </li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Políticas y Procedimientos para Conductores adicionales :</h2>
        <p>
          <li>
          El conductor adicional debe ser mayor de 25 años de edad y menor o igual a 70 años.
          </li>
          <li>Licencia de conducir vigente.</li>
          <li>
          Tener la categoría adecuada para el tipo de modelo de vehículo que conducirá.
          </li>
          <li>
          Sin Infracciones automovilísticas y/o de tránsito (multas).
          </li>
          <li>
          Todos los documentos requeridos serán escaneados y/o fotocopiados por Budget Rent a Car.
          </li>
          <li>
          Los conductores deben estar presentes al aperturar el contrato de arrendamiento en la sucursal. Deben presentar sus documentos necesarios para ser agregados (cumplir todos los requisitos de conductores adicionales).
          </li>
          <li>
          Se deberá llenar y firmar la esquela del conductor adicional la cual será entregada en el counter al momento de apertura del contrato. Y deberá ser firmada y autorizada por el cliente responsable del contrato.
          </li>
          <li>
          En caso de que el conductor adicional no esté presente al momento de apertura del contrato y deseen agregarlo posteriormente deberán presentarse: el cliente, el conductor adicional y el vehículo arrendado en la sucursal más cercana y firmar la documentación requerida (Cumplir todos los requisitos de conductores adicionales).
          </li>
          <li>El conductor adicional no tiene ningún costo en caso de: Cónyuge del arrendatario, Cuando el titular no puede conducir o no tiene una licencia para tal.</li>
          <li>
          El conductor (es) adicional (es) tiene (n) un costo de US$ 5.00 por día (US$ 10 por día en caso de rentas fuera del país), cuando no cumple con lo siguiente: Cónyuge del arrendatario , Cuando el titular no puede conducir o no tiene una licencia para tal
          </li>
          <li> La cantidad máxima de conductores adicionales será de 4.</li>
          <li>
          El monto máximo a pagar por cada conductor adicional será de US$ 100.00 mensuales por contrato de renta.
          </li>
          <li>Nos reservamos el derecho de aceptar o no al conductor adicional.</li>
          <li>El conductor adicional no podrá modificar el contrato de renta original, en ninguno de sus términos.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />
      </div>
    </div>

    <h1>Términos y Condiciones de Rentas Pre-Pagadas en Línea</h1>
    <br />
    <div className="wrapper">
      <div>
        <p>
          <li> El contrato de renta saldrá a nombre de quien realice la reservación y el pre-pago y la persona deberá cumplir con los requisitos de renta establecidos.</li>
          <li> La edad mínima para clientes y conductores es de 25 años</li>
          <li> Poseer licencia de conducir vigente (No Boleta)</li>
          <li> Presentar documento de Identificación (Cedula de identidad o Pasaporte)</li>
          <li> La tarjeta de crédito o débito debe estar a nombre del cliente que realizó el pre-pago en línea.</li>
          <li> El cliente que realice el pre-pago en línea deberá presentar en el counter la misma tarjeta de crédito o débito que utilizó para realizar el pre-pago.</li>
          <li> Al momento de efectuar el contrato de arrendamiento el cliente deberá presentar la misma tarjeta que utilizóen el pre-pago y adicional deberá dejar un depósito para la renta del vehículo (el depósito debe ser con la misma tarjeta y contar con disponibilidad mínima de U$S 500.00 - US$ 800.00 o más en dependencia del monto y tiempo de la renta).</li>
          <li> En caso de utilizar tarjeta de crédito y débito la cobertura obligatoria a tomar es US$ 12.99 por día, las demás coberturas para proteger al vehículo son opcionales.</li>
          <li> El contrato de arrendamiento es por 30 días, en caso de que su reservación pre-pagada sea por más tiempo del estipulado, deberá realizar renovación de contrato mensual con presencia del vehículo en cualquiera de nuestras sucursales.</li>
        </p>
        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>No se permite cambios en la reserva en línea.</h2>
        <p>
          <li>Para cualquier tipo de cambio una vez realizada la reservación deberá comunicarse al Departamento de Reservaciones a reservaciones@budget.com.ni, reserve@budget.com.ni o llamar al (505) 2255-9000, desde USA (786) 955-9000, los cambios pueden tener cargos adicionales.</li> 
        </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />


        <h2>Penalidad por cancelación en la reserva en línea.</h2>
        <p>
          <li>Las cancelaciones recibidas 72 horas o más antes de la fecha de su reservación, no se cobrará ninguna penalidad.</li> 
          <li>Las cancelaciones recibidas entre 24 - 72 horas antes de la fecha de su reservación, la penalidad será de $25.00 (veinticinco dólares netos) o el total de la renta (en caso de que el pre-pago sea menor al cargo de penalidad) y se cobrarán de la misma tarjeta de crédito o débito con la que realizó el pre-pago.</li>
          <li>Las cancelaciones recibidas menos de 24 horas antes de la fecha de su reservación, la penalidad será de 50.00 (cincuenta dálares netos) o el total de la renta (en caso de que el pre-pago sea menor al cargo de penalidad) y se cobrarán de la misma tarjeta de crédito o débito con la que realizó el pre-pago.</li>
          <li>Ya efectuada la reservación con pre-pago incluido, si el vehículo es retornado antes de la fecha acordada en el contrato de arrendamiento, no se realizará ningún reembolso.</li>
        </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

        <h2>Penalidad por No Presentarse.</h2>
        <p>
          <li>Si no se presenta al momento de la reservación, su vehículo quedará reservado por 2 horas adicionales, al pasar el período se cobrará la totalidad de su reservación y el vehículo se liberará y podrá ser alquilado por otro cliente.</li> 
           </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

         <h2>Solicitud de Reembolsos Si aplica.</h2>
        <p>
          <li>Las solicitudes de reembolso de la reservaciones cancelada se deben de solicitar a reservaciones@budget.com.ni, reserve@budget.com.ni o llamando al (505) 2255-9000, desde USA (786) 955-9000, en horario de 8:00 a.m. a 5:30 p.m. de lunes a viernes hora de Nicaragua.</li> 
          <li>La solicitud de reembolso debe ser realizada por el cliente por un máximo de 15 días después de la fecha de cancelación de la reserva en línea caso contrario no se realizará el reembolso.</li> 
          <li>Los reembolsos no se pueden pagar en el mostrador, ni en efectivo, estos serán acreditados a la misma tarjeta de crédito o débito que utilizó para realizar el pre-pago, dentro de los siguientes 15 días hábiles después de recibida su solicitud.</li> 
           </p>

        <div
          style={{
            background: '#F78621',
            height: '3px',
            margin: '0px 0px 20px 0px',
          }}
        />

   
      </div>
    </div>


  </div>
)
export default termsConditionsEs*/




import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'


class termsConditionsEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionTerminosEs: '',

      titleTerminos:{
        en: '',
        es: ''
      },

      titleTerminosNaranja:{
        en: '',
        es: ''
      },

      

    }

    this.renderTextsTerminos = this.renderTextsTerminos.bind(this)

    
  }
  componentDidMount() {

      axios
      .get(`${backendURL}/api/texts/sections/TextTerminos/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionTerminosEs:{
            es: txt.descriptionTerminosEs,
          }, 

          titleTerminos:{
            en: txt.titleTerminos.en,
            es: txt.titleTerminos.es
          },

          titleTerminosNaranja:{
            en: txt.titleTerminosNaranja.en,
            es: txt.titleTerminosNaranja.es
          },


          


        })
        })

    

      .catch(err => {
        console.log(err)
      })
  }


  renderTextsTerminos() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionTerminosEs , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>

          <p> 
            {titleTerminos.es} 
          </p>

          <p> 
            {titleTerminosNaranja.es} 
          </p>
          
          <p> 
            {descriptionTerminosEs.es} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'es',
             href:
               './es/corporate_program',
           },
         ]}
       />
      
   <h1> {this.state.titleTerminos.es}</h1>

   <div style={{background: '#F78621' , height: '55px', margin:'-15px 0 15px 0', color:'#fff' ,padding:' 1% 0% 1% 0%', textAlign: 'center'}}>
          <p>
          
          {this.state.titleTerminosNaranja.es}
          
          </p>
    </div>

   
    
    <div dangerouslySetInnerHTML={{__html: this.state.descriptionTerminosEs.es}}></div>
</div>
    )
  }
}
export default termsConditionsEs




// WEBPACK FOOTER //
// ./src/pages/terms_conditions.es.js